import { IsNumber, IsOptional, IsString } from 'class-validator'

export class SaveCsrFormChangeLog {
  @IsNumber()
  formId!: number

  @IsNumber()
  userId: number | undefined

  @IsString()
  @IsOptional()
  oldValue?: string | null

  @IsString()
  newValue!: string

  @IsString()
  action!: 'updated' | 'created' | 'deleted' | 'patched'
}
